import React from 'react';
import Slider from 'react-slick';
import { CarouselContainer, CarouselImage } from './CientsCarousel.styles';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import jumio from '../../assets/images/UseCases/jumio.png';
import quienesquien from '../../assets/images/UseCases/quien-es-quien.png';
import stp from '../../assets/images/UseCases/stp.png';
import circulo from '../../assets/images/UseCases/circulo-credito.png';
import tiaxa from '../../assets/images/UseCases/tiaxa.png';
import visa from '../../assets/images/UseCases/visa.png';
import naat from '../../assets/images/UseCases/naat.png';

const images = [jumio, quienesquien, stp, circulo, tiaxa, visa, naat];

const PrevArrow = ({ className, onClick }) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    aria-label="Anterior"
  >
    <ChevronLeftRoundedIcon />
  </button>
);

const NextArrow = ({ className, onClick }) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    aria-label="Siguiente"
  >
    <ChevronRightRoundedIcon />
  </button>
);

const settings = {
  dots: false,
  infinite: true,
  arrows: true,
  autoplay: true,
  speed: 550,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  pauseOnFocus: true,
  swipeToSlide: true,
  draggable: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  cssEase: 'ease',
  rtl: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      }
    }
  ]
};

const ClientCarousel = () => {
  return (
    <CarouselContainer>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <CarouselImage src={image} alt={`Imagen ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default ClientCarousel;
